import type {LabelPickerBaseProps, LabelPickerLabel as LabelPickerBaseLabel} from '@github-ui/item-picker-label'

import {LabelPickerTsqWithRelayWrapper} from './LabelPickerTsqWithRelayWrapper'

export type LabelPickerLabel = LabelPickerBaseLabel

export type LabelPickerProps = Omit<LabelPickerBaseProps, 'filterItems'> & {
  labelNames?: string[]
}

export function LabelPicker(props: LabelPickerProps) {
  return <LabelPickerTsqWithRelayWrapper {...props} />
}

try{ LabelPicker.displayName ||= 'LabelPicker' } catch {}